import React from "react";
import { RatingReviewMarketStarsView } from "./view";
import { styles } from "./styles";

export const RatingReviewMarketStars = props => (
  <RatingReviewMarketStarsView {...props} styles={styles} />
);
